import React from "react";
import { UseFormRegister } from "react-hook-form";
import {
    FirstNameField,
    LastNameField,
    AddressField,
    CityField,
    StateField,
    ZipCodeField,
    PhoneNumberField,
} from "components/form-fields";

interface SecondaryAddresseeFieldsProps {
    register: UseFormRegister<any>;
    errors: any;
    state?: string;
    phone?: string;
}

/**
 * Grouped form fields for secondary addressee contact information
 */
const SecondaryAddresseeFields = ({ register, errors, state, phone }: SecondaryAddresseeFieldsProps) => {
    return (
        <>
            <p className="text-lg font-bold leading-7 text-base-content pb-3">Secondary Addressee</p>

            <div className="flex flex-col gap-3">
                <div className="flex gap-2">
                    <FirstNameField
                        register={register("secondaryAddressee.firstName")}
                        error={errors.secondaryAddressee?.firstName?.message}
                        id="secondary-addressee-firstName"
                        className="blur-upscope"
                    />
                    <LastNameField
                        register={register("secondaryAddressee.lastName")}
                        error={errors.secondaryAddressee?.lastName?.message}
                        id="secondary-addressee-lastName"
                        className="blur-upscope"
                    />
                </div>

                <AddressField
                    register={register("secondaryAddressee.address")}
                    error={errors.secondaryAddressee?.address?.message}
                    id="secondary-addressee-address"
                    className="blur-upscope"
                />

                <CityField
                    register={register("secondaryAddressee.city")}
                    error={errors.secondaryAddressee?.city?.message}
                    id="secondary-addressee-city"
                    className="blur-upscope"
                />

                <div className="flex gap-3">
                    <div className="flex-[2] min-w-0">
                        <StateField
                            register={register("secondaryAddressee.state")}
                            error={errors.secondaryAddressee?.state?.message}
                            value={state}
                            isEditable={false}
                            id="secondary-addressee-state"
                            fullWidth
                            className="blur-upscope"
                        />
                    </div>
                    <div className="flex-1 min-w-0">
                        <ZipCodeField
                            register={register("secondaryAddressee.zipCode")}
                            error={errors.secondaryAddressee?.zipCode?.message}
                            id="secondary-addressee-zipCode"
                            className="blur-upscope"
                        />
                    </div>
                </div>

                <PhoneNumberField
                    register={register("secondaryAddressee.phone")}
                    error={errors.secondaryAddressee?.phone?.message}
                    value={phone || ""}
                    width="w-full"
                    id="secondary-addressee-phone"
                    className="blur-upscope"
                />
            </div>
        </>
    );
};

export default SecondaryAddresseeFields;
